export default "__VITE_ASSET__3edf49e8__"